import MaintenancePage from "../MaintenancePage";
import resource from "../../resources/loanTypeResource";

export default function LoanTypes() {
    return <MaintenancePage resource={resource} />;
}
